import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslation } from 'hooks/useTranslation';
import {
  HeroSection,
  HeroContainer,
  HeroImageWrapper,
  HeroCopyColumn,
  CopyInner,
  HeroHeading,
  HeroParagraph,
} from './Hero.styles';
import { Button } from 'components/Button';
import imageSrc from '../../../../../public/assets/raw-benefits/two-golden-retrievers-we-feed-raw-bowl.webp'

type HeroProps = {
};

export const Hero: React.FC<HeroProps> = () => {
  const { t } = useTranslation();

  return (
    <HeroSection aria-labelledby="raw-benefits-hero-heading">
      <HeroContainer>
        <HeroImageWrapper>
          <Image
            src={imageSrc}
            alt={t('raw-benefits:hero.image-alt')}
            sizes="(min-width: 900px) 50vw, 100vw"
            priority
            layout="fill"
          />
        </HeroImageWrapper>

        <HeroCopyColumn>
          <CopyInner>
            <HeroHeading id="raw-benefits-hero-heading">
              {t('raw-benefits:hero.title')}
            </HeroHeading>

            <HeroParagraph color='accent-white'>
              {t('raw-benefits:hero.body')}
            </HeroParagraph>

            <Link href='/meal-plan' passHref>
                <Button className='cta hero' variant="primary" as="a">
                    {t('raw-benefits:hero.primary-cta')}
                </Button>
            </Link>
          </CopyInner>
        </HeroCopyColumn>
      </HeroContainer>
    </HeroSection>
  );
};

